import { StarBg } from '@components/common/icons/custom-icons'

interface NumberedStarCardProps {
  id: number
  title: string
  description: string
  textColor: string
  className?: string
  titleClassName?: string
  descriptionClassName?: string
}

const NumberedStarCard = ({
  id,
  title,
  description,
  textColor,
  className = '',
  titleClassName = 'text-xl font-700 mb-4 leading-tight',
  descriptionClassName = 'text-base',
}: NumberedStarCardProps): JSX.Element => (
  <div
    className={`bg-white rounded-xl border border-blue-50 hover:border-blue-200 transition-all duration-300 shadow-2d-blue ${className}`}
  >
    <div className="relative w-16 h-16 mb-4">
      <StarBg
        className={`absolute left-1/2 w-16 h-16 transform -translate-x-1/2 ${textColor} opacity-25`}
      />
      <div className="flex justify-center items-center relative">
        <span className={`text-4xl font-700 ${textColor} leading-relaxed`}>
          {id}
        </span>
      </div>
    </div>
    <h3 className={titleClassName}>{title}</h3>
    <p className={descriptionClassName}>{description}</p>
  </div>
)

export default NumberedStarCard
